import { render } from "./SelectLeituras.vue?vue&type=template&id=6d5b1872"
import script from "./SelectLeituras.vue?vue&type=script&lang=js"
export * from "./SelectLeituras.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__